import React from "react";
import { useTranslation } from "react-i18next";
import { CommodityType } from "@/pages/EditMyAccount";
import ElipsedText from "@/components/common/elipsis/ElipsedText";

interface UserDetails {
  user_type: {
    id: number;
  };
  companies?: Array<{
    id: number;
    name: string;
    trading_as: string;
    commodity_types: CommodityType[];
    administrative_first_name: string;
    administrative_last_name: string;
    administrative_email: string;
    administrative_contact_number: string;
    designation: string;
    facility_required?: boolean;
    facility_amount?: number;
    debtor_type?: {
      debtor_type: string;
      id: number;
    };
    payment_terms?: {
      payment_term: string;
      id: number;
    };
    client_type?: {
      client_type: string;
      id: number;
    };
    credit_facility: string | null;
    profession?: {
      title: string;
      id: number;
    };
    reason_to_access?: string;
  }>;
}

interface RenderOtherDetailsProps {
  userDetails: UserDetails;
}

const RenderOtherDetails: React.FC<RenderOtherDetailsProps> = ({
  userDetails,
}) => {
  const { t } = useTranslation();
  const userType = userDetails.user_type.id;

  switch (userType) {
    case 4: // Tier 4
      return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-6">
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.facilityRequired")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.facility_required ? "Yes" : "No"}
            </p>
          </div>
          {userDetails.companies?.[0]?.facility_required && (
            <div>
              <p className="tw-text-sm font-gray-color tw-font-medium">
                {t("myAccount.otherDetails.facilityAmount")}
              </p>
              <p className="tw-font-medium font-primary-color tw-mt-1">
                <ElipsedText
                  text={`R ${
                    userDetails.companies?.[0]?.facility_amount?.toLocaleString() ||
                    "R 0"
                  }`}
                  maxLength={10}
                  shouldWrap={true}
                />
              </p>
            </div>
          )}
        </div>
      );

    case 5: // Tier 5
      return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-6">
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.debtorType")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.debtor_type?.debtor_type}
            </p>
          </div>
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.paymentTerms")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.payment_terms?.payment_term}
            </p>
          </div>
          <div className="tw-flex tw-gap-2 tw-items-start">
            <div>
              <p className="tw-text-sm font-gray-color tw-font-medium">
                {t("myAccount.otherDetails.clientType")}
              </p>
              <p className="tw-font-medium font-primary-color tw-mt-1">
                {userDetails.companies?.[0]?.client_type?.client_type}
              </p>
            </div>
            {/* {userDetails.companies?.[0]?.client_type === 1 && (
              <div className="tw-bg-[#F8FAFC] tw-rounded-md tw-p-3 tw-border tw-border-[#E9EAEB]">
                <p className="tw-text-sm font-gray-color tw-font-medium">
                  Credit Facility Number
                </p>
                <p className="tw-font-medium font-primary-color tw-mt-1">
                  {userDetails.companies?.[0]?.credit_facility || "-"}
                </p>
              </div>
            )} */}
          </div>
        </div>
      );

    case 6: // Tier 6
      return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-6">
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.profession")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.profession?.title || "-"}
            </p>
          </div>
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.reasonToAccess")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.reason_to_access || "-"}
            </p>
          </div>
        </div>
      );

    case 7: // Tier 7
      return (
        <div className="tw-grid tw-grid-cols-2 tw-gap-6">
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.profession")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.profession?.title || "-"}
            </p>
          </div>
          <div>
            <p className="tw-text-sm font-gray-color tw-font-medium">
              {t("myAccount.otherDetails.reasonToAccess")}
            </p>
            <p className="tw-font-medium font-primary-color tw-mt-1">
              {userDetails.companies?.[0]?.reason_to_access || "-"}
            </p>
          </div>
        </div>
      );

    default:
      return null;
  }
};

export default RenderOtherDetails;
